// removed by extract-text-webpack-plugin
module.exports = {"qrSteps":"QRSteps__qrSteps","title":"QRSteps__title","qrStepsContent":"QRSteps__qrStepsContent","step":"QRSteps__step","number":"QRSteps__number","stepTitle":"QRSteps__stepTitle","gear":"QRSteps__gear","cssAnimation":"QRSteps__cssAnimation","badges":"QRSteps__badges","badge":"QRSteps__badge","playBadge":"QRSteps__playBadge","stepImage1":"QRSteps__stepImage1","stepImage2":"QRSteps__stepImage2","rememberMe":"QRSteps__rememberMe","growDotQello":"QRSteps__growDotQello","growDotBlue":"QRSteps__growDotBlue","growDotGolden":"QRSteps__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QRSteps/QRSteps.scss
// module id = 1881
// module chunks = 0